import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { INavigateAway } from "./NavigationGuard";

@Injectable({
    providedIn:'root'
})
export class DeactivateGuard {

    constructor(){}
    
    canDeactivate(component:INavigateAway,
        route:ActivatedRouteSnapshot,
        state:RouterStateSnapshot,
        nextState:RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean
    {
        return component.formsNotEdited() ? true:component.canExit(); 
    }
}